// extracted by mini-css-extract-plugin
module.exports = {"link":"CollegeCoachesComponent_link__1z3eK","flex":"CollegeCoachesComponent_flex__1cgOn","table":"CollegeCoachesComponent_table__2PnZM"};